import React, { useState, useEffect, useRef } from 'react';
import {
    Typography,
    Grid,
    Box,
    CssBaseline,
    Divider,
    Tabs,
    Tab,
    TextField,
    MenuItem,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, AreaChart, Area, Legend, ResponsiveContainer, BarChart, Bar, PieChart, Pie, Cell } from 'recharts';
import { Analytics } from '@mui/icons-material';
import axios from 'axios';
import { global_link } from '../Components/Globallink';
import { saveAs } from 'file-saver';

const Analyticz = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [activeMiniTab, setActiveMiniTab] = useState(0);
    const [activeMini2Tab, setActiveMini2Tab] = useState(0);
    const [isGenerating, setIsGenerating] = useState(false);
    const today = new Date().toISOString().split('T')[0];
    
    const [formData, setFormData] = useState({
      keyword: '',
      start_date: '',
      end_date: '',
      user_id: ''
    });

    const [usersData, setUsersData] = useState([]);
    const [ticketingGroupData, setTicketingGroupData] = useState([]);
    const [breakGroupData, setBreakGroupData] = useState([]);
    const [dispostionGroupData, setDispostionGroupData] = useState([]);
    
    // Existing Chart Data
    const [chartData, setChartData] = useState([]);
    const [chartCallData, setChartCallData] = useState([]);
    const [chartTalkTimeData, setChartTalkTimeData] = useState([]);
    
    // New Chart Data States
    const [individualChartData, setIndividualChartData] = useState([]);
    const [ticketingChartData, setTicketingChartData] = useState([]);
    const [dispositionChartData, setDispositionChartData] = useState([]);
    const [breakChartData, setBreakChartData] = useState([]);
    const [loginChartData, setLoginChartData] = useState([]);
    const [waitingChartData, setWaitingChartData] = useState([]);
    const [waitingSummary, setWaitingSummary] = useState(null);
    const [callMixChartData, setCallMixChartData] = useState([]);

    const PIE_COLORS = ['#5CB338', '#FF0000', '#FFA500', '#79B6BC', '#8884d8', '#d32f2f', '#3f51b5', '#ffc658', '#82ca9d'];

    const api = axios.create({baseURL: global_link});
    const authToken = process.env.AUTH_TOKEN;
  

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        setActiveMiniTab(0);
        setActiveMini2Tab(0);
    };

    const handleMiniTabChange = (event, newValue) => {
        setActiveMiniTab(newValue);
    };
    const handleMini2TabChange = (event, newValue) => {
        setActiveMini2Tab(newValue);
    };

    // Reset chart data + filters for a Stats Graph tab
    const resetStatsGraphTab = (tabIndex = activeMini2Tab) => {
        switch (tabIndex) {
            case 0:
                setChartCallData([]);
                setCallMixChartData([]);
                break;
            case 1:
                setIndividualChartData([]);
                break;
            case 2:
                setTicketingChartData([]);
                break;
            case 3:
                setDispositionChartData([]);
                break;
            case 4:
                setChartData([]);
                break;
            case 5:
                setBreakChartData([]);
                break;
            case 6:
                setLoginChartData([]);
                break;
            case 7:
                setChartTalkTimeData([]);
                break;
            case 8:
                setWaitingChartData([]);
                setWaitingSummary(null);
                break;
            default:
                break;
        }
        setFormData((prev) => ({
            ...prev,
            keyword: '',
            start_date: '',
            end_date: '',
            user_id: '',
        }));
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      };

function calculateTimeDifference(start, end) {
  if (!start || !end) return '';
  const startTimeParts = start.split(":");
  const endTimeParts = end.split(":");

  const startHour = parseInt(startTimeParts[0]);
  const startMinute = parseInt(startTimeParts[1]);
  const startSecond = parseInt(startTimeParts[2]);

  const endHour = parseInt(endTimeParts[0]);
  const endMinute = parseInt(endTimeParts[1]);
  const endSecond = parseInt(endTimeParts[2]);

  let startTotalSeconds = startHour * 3600 + startMinute * 60 + startSecond;
  let endTotalSeconds = endHour * 3600 + endMinute * 60 + endSecond;

  let diffInSeconds = endTotalSeconds - startTotalSeconds;
  if (diffInSeconds < 0) {
    diffInSeconds += 24 * 3600;
  }
  
  const hours = Math.floor(diffInSeconds / 3600);
  const minutes = Math.floor((diffInSeconds % 3600) / 60);
  const seconds = diffInSeconds % 60;
  return `${hours} h ${minutes} m ${seconds} s`;
}

function timeToSeconds(time) {
    if (time == null || time === '') return 0;
    // Already numeric seconds
    if (typeof time === 'number' && Number.isFinite(time)) {
      return Math.max(0, Math.round(time));
    }
    const str = String(time).trim();
    if (!str) return 0;
    // Pure number string
    if (/^\d+(\.\d+)?$/.test(str)) {
      return Math.max(0, Math.round(parseFloat(str)));
    }
    // HH:MM:SS or MM:SS (strip fractional seconds)
    const sanitized = str.split('.')[0];
    const parts = sanitized.split(':').map((p) => parseInt(p, 10) || 0);
    if (parts.length === 3) {
      const [hours, minutes, seconds] = parts;
      return (hours * 3600) + (minutes * 60) + seconds;
    }
    if (parts.length === 2) {
      const [minutes, seconds] = parts;
      return (minutes * 60) + seconds;
    }
    return 0;
}

// Shared chart container — prevents Recharts overflow past parent divs
const chartBoxSx = {
  width: '100%',
  maxWidth: '100%',
  height: 380,
  mt: 3,
  overflow: 'hidden',
  position: 'relative',
  boxSizing: 'border-box',
  '& .recharts-responsive-container': {
    width: '100% !important',
    maxWidth: '100%',
  },
  '& .recharts-wrapper': {
    maxWidth: '100% !important',
  },
};

    const fetchUsersData = async () => {
      try {
          const authyToken = localStorage.getItem(authToken);
          const response = await api.get('/user/usersrestrict/', {
              headers: {
                  Authorization: `Bearer ${authyToken}`,
              },
          });
          setUsersData(response.data);
      } catch (error) {
          console.error('Error fetching Users:', error);
      }
    };

    // --- Download Handlers (Preserved) ---

    const handleCallReportSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        const headers = {
          Authorization: `Bearer ${authyToken }`,
          "Content-Type": "application/json",
        };
        try {
          const response = await api.get('/report/callreports/', {
            params: {
              keyword: formData.get('keyword'),
              start_date: formData.get('start_date'),
              end_date: formData.get('end_date'),
            },     
              headers,
              withCredentials: true,
          });
          if(response.data.length>0){
            let headings;
            if(formData.get('keyword')!=="Received"){
              headings = ['Name','Source','Destination','Call Status','Call Type','Disconnect Direction','Time/Date'];
            }else{
              headings = ['Name','Source','Destination','Duration','Call Type','Disconnect Direction','Time/Date'];
            }
            const csvContent = [headings.join(',')].concat(response.data.map(item => [
              item.user_name,
              item.call_from,
              item.call_to,
              item.call_duration,
              item.call_type,
              item.disconnect_direction || '',
              item.call_time
            ].join(','))).join('\n');
            const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(csvBlob,`${formData.get('keyword')}-${formData.get('start_date')}-${formData.get('end_date')}-${formData.get('report')}_Report.csv`);
          }else{
            // setOpenError(true);
          }
        } catch (error) {
          console.error('Error fetching data:', error);  
        }
      };


      const handleIndividualCallReportSubmit = async (event) => {
        let userNameSelect;
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        const user_id = formData.get('user_id');
        const headers = {
          Authorization: `Bearer ${authyToken }`,
          "Content-Type": "application/json",
        };
        try {
            if (!user_id) {
              console.error('User ID is missing');
              userNameSelect = 'No Name';
              return;
            }
            const response = await api.get(`/user/getuser/${user_id}`, {    
              headers,
              withCredentials: true,
            });
            if (response.data && response.data.user_name && response.data.user_extension) {
              userNameSelect = `${response.data.user_name}-(${response.data.user_extension})`;
            } else {
              userNameSelect = 'No Name';
            }
          } catch (error) {
            console.error('Error fetching user data:', error.message || error);
            userNameSelect = 'No Name';  
          }
        try {
          const response = await api.get('/report/individualcallreport/', {
            params: {
              keyword: formData.get('keyword'),
              start_date: formData.get('start_date'),
              end_date: formData.get('end_date'),
              user_id: formData.get('user_id'),
            },     
              headers,
              withCredentials: true,
          });
          if(response.data.length>0){
            let headings;
            if(formData.get('keyword')!=="Received"){
              headings = ['Name','Source','Destination','Call Status','Call Type','Disconnect Direction','Time/Date'];
            }else{
              headings = ['Name','Source','Destination','Duration','Call Type','Disconnect Direction','Time/Date'];
            }
            const csvContent = [headings.join(',')].concat(response.data.map(item => [
              item.user_name,
              item.call_from,
              item.call_to,
              item.call_duration,
              item.call_type,
              item.disconnect_direction || '',
              item.call_time
            ].join(','))).join('\n');
            const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(csvBlob,`${userNameSelect} - ${formData.get('keyword')}-${formData.get('start_date')}-${formData.get('end_date')}-${formData.get('report')}_Report.csv`);
          }else{
            // setOpenError(true);
          }
        } catch (error) {
          console.error('Error fetching data:', error);  
        }
      };

      const handleContactReportSubmit = async (event) => {
        event.preventDefault();
        const authyToken = localStorage.getItem(authToken);
        const headers = {
          Authorization: `Bearer ${authyToken}`,
          "Content-Type": "application/json",
        };
        try {
          const response = await api.get('/report/contactreport/', {
            headers,
            withCredentials: true,
          });
          if(response.data.length>0){
            const headings = ['Name','Contact','Email','Alternative Contact','Category','Business','Home','Location','Department','Date'];
            const csvContent = [headings.join(',')].concat(response.data.map(item => [item.name,item.phone_number,item.email,item.alternative_phone_number,item.category,item.business,item.home,item.department,item.date].join(','))
            ).join('\n');
            const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(csvBlob,`Contacts_Export-Report.csv`);
          }else{
            // setOpenError(true);
          }
        } catch (error) {
          console.error('Error fetching data:', error);  
        }
      }

      const fetchTicketingCategoryGroup = async () => {
        try {
            const authyToken = localStorage.getItem(authToken);
            const response = await api.get('/ticketing/categorygroup/', {
                headers: {
                    Authorization: `Bearer ${authyToken}`,
                },
            });
            setTicketingGroupData(response.data);
        } catch (error) {
            console.error('Error fetching Users:', error);
        }
      };

      const fetchDispositionCategoryGroup = async () => {
        try {
            const authyToken = localStorage.getItem(authToken);
            const response = await api.get('/disposition/group/', {
                headers: {
                    Authorization: `Bearer ${authyToken}`,
                },
            });
            setDispostionGroupData(response.data);
        } catch (error) {
            console.error('Error fetching Users:', error);
        }
      };

      const handleTicketingReport = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        const headers = {
          Authorization: `Bearer ${authyToken}`,
          "Content-Type": "application/json",
        };
        try {
          const response = await api.get('/report/ticketingreport/', {
            params: {
              keyword: formData.get('keyword'),
              start_date: formData.get('start_date'),
              end_date: formData.get('end_date'),
            },
            headers,
            withCredentials: true,
          });
          if (response.data.length > 0) {
            const headings = ['Ticket Id','Name','Subject','Description','Status','Priority','Category','Sub Category','Phone Number','Alt Phone Number','Channel','Date'];
            const escapeCSV = (value) => {
              if (value == null) return '';
              const stringValue = String(value).replace(/"/g, '""');
              return `"${stringValue}"`;
            };
            const csvRows = [headings.map(escapeCSV).join(','), ...response.data.map(item => [item.id, item.user_name, item.subject, item.description, item.status, item.priority, item.category, item.sub_category, item.phone_number, item.alternative_phone_number, item.channel, item.created_at].map(escapeCSV).join(','))];
            const csvContent = csvRows.join('\n');
            const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(csvBlob,`${formData.get('keyword') || 'All'}-${formData.get('start_date')}-${formData.get('end_date')}-Ticket_Report.csv`);
          } else {
            alert("No data found for the given filters.");
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          alert("An error occurred while generating the report.");
        }
      };

      const handleDispositionReport = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
        try {
          const response = await api.get('/report/dispositionreport/', {
            params: { keyword: formData.get('keyword'), start_date: formData.get('start_date'), end_date: formData.get('end_date') },
            headers, withCredentials: true,
          });
          if (response.data.length > 0) {
            const headings = ['User', 'Contact', 'Call Type', 'Disposition', 'Disposition Category', 'Disposition Sub Category', 'Disposition Info', 'Date'];
            const escapeCSV = (value) => { if (value == null) return ''; return `"${String(value).replace(/"/g, '""')}"`; };
            const csvRows = [headings.map(escapeCSV).join(','), ...response.data.map(item => [item.user_name, item.disposition_contact, item.call_type, item.disposition, item.disposition_category, item.disposition_sub_category, item.disposition_info, item.disposition_time].map(escapeCSV).join(','))];
            const csvContent = csvRows.join('\n');
            const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(csvBlob, `${formData.get('keyword') || 'All'}-${formData.get('start_date')}-${formData.get('end_date')}-Disposition_Report.csv`);
          } else { alert("No disposition data found for the selected filters."); }
        } catch (error) { console.error('Error fetching data:', error); alert("An error occurred while generating the disposition report."); }
      };

      const handlePerformanceReportSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
        try {
          const response = await api.get('/report/performancereport/', {
            params: { start_date: formData.get('start_date'), end_date: formData.get('end_date') }, headers, withCredentials: true,
          });
          if (response.data.length > 0) {
            const headings = ['(Extension) User', 'All Calls', 'Outgoing', 'Incoming', 'Answered', 'Missed', 'No Answer', 'Busy', 'Rejected', 'Total Talk Time'];
            let totalCallCount = 0, totalOutgoing = 0, totalIncoming = 0, totalReceived = 0, totalMissed = 0, totalNoAnswer = 0, totalSeconds = 0, totalBusy = 0, totalRejected = 0;
            response.data.forEach(item => {
              totalCallCount += Number(item.call_count); totalOutgoing += Number(item.total_outgoing); totalIncoming += Number(item.total_incoming);
              totalReceived += Number(item.received); totalMissed += Number(item.missed); totalNoAnswer += Number(item.no_answer);
              totalBusy += Number(item.busy); totalRejected += Number(item.rejected);
              const durationParts = item.total_duration.split(':').map(Number);
              totalSeconds += durationParts[0] * 3600 + durationParts[1] * 60 + durationParts[2];
            });
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            const formattedTotalDuration = `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            const footerRow = ['Total', `${totalCallCount}`, `${totalOutgoing}`, `${totalIncoming}`, `${totalReceived}`, `${totalMissed}`, `${totalNoAnswer}`, `${totalBusy}`, `${totalRejected}`, `${formattedTotalDuration}`];
            const csvContent = [headings.join(',')].concat(response.data.map(item => [`(${item.user_extension}) ${item.user_name}`, item.call_count, item.total_outgoing, item.total_incoming, item.received, item.missed, item.no_answer, item.busy, item.rejected, item.total_duration].join(','))).concat([footerRow.join(',')]).join('\n');
            const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(csvBlob, `Performance_Report-${formData.get('start_date')}_${formData.get('end_date')}.csv`);
          }
        } catch (error) { console.error('Error fetching data:', error); }
      }

      const fetchBreakGroup = async () => {
        try {
            const authyToken = localStorage.getItem(authToken);
            const response = await api.get('/break/group/', { headers: { Authorization: `Bearer ${authyToken}` } });
            setBreakGroupData(response.data);
        } catch (error) { console.error('Error fetching Break Group:', error); }
      };

      const fetchLoginData = async () => {
        try {
            const authyToken = localStorage.getItem(authToken);
            const response = await api.get('/report/logingroupuser/', { headers: { Authorization: `Bearer ${authyToken}` } });
            setLoginData(response.data); // Assuming loginData state was missing in original but needed
        } catch (error) { console.error('Error fetching Users:', error); }
      };
      
      const [loginData, setLoginData] = useState([]); // Added state that was missing

      const handleLoginReportSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
        try {
          const response = await api.get('/report/logingroupdata/', {
            params: { keyword: formData.get('keyword'), start_date: formData.get('start_date'), end_date: formData.get('end_date') }, headers, withCredentials: true,
          });
          if(response.data.length>0){
            const headings = ['Name','Login Time', 'LogOut Time', 'Duration'];
            const csvContent = [headings.join(',')].concat(response.data.map(item => [item.user_name,item.connected_at.replace('T', ' '),item.disconnected_at.replace('T', ' '), item.duration_readable].join(','))).join('\n');
            const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(csvBlob,`${formData.get('keyword')}-${formData.get('start_date')}-${formData.get('end_date')}-Login_Report.csv`);
          }
        } catch (error) { console.error('Error fetching data:', error); }
      }

      const handleBreakReportSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        const headers = { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" };
        try {
          const response = await api.get('/report/breaksreport/', {
            params: { keyword: formData.get('keyword'), start_date: formData.get('start_date'), end_date: formData.get('end_date') }, headers, withCredentials: true,
          });
          if(response.data.length>0){
            const headings = ['Name','Break','Start','Stop','Duration','Date'];
            const csvContent = [headings.join(',')].concat(response.data.map(item => [item.user_name,item.break,item.start_time,item.end_time,calculateTimeDifference(item.start_time, item.end_time),item.date.replace('T', ' ').split('.')[0]].join(','))).join('\n');
            const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(csvBlob,`${formData.get('keyword')}-${formData.get('start_date')}-${formData.get('end_date')}-Break_Report.csv`);
          }
        } catch (error) { console.error('Error fetching data:', error); }
      }

      const handleExtensiveReportSubmit = async (event) => {
        event.preventDefault();
        if (isGenerating) return;
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        const startDateStr = formData.get('start_date');
        const endDateStr = formData.get('end_date');
        if (!startDateStr || !endDateStr) { alert('Please select both start and end dates.'); return; }
        setIsGenerating(true);
        try {
          const response = await api.get('/report/extensivereport/', {
            params: { keyword: formData.get('keyword'), start_date: startDateStr, end_date: endDateStr },
            headers: { Authorization: `Bearer ${authyToken}`, "Content-Type": "application/json" }, withCredentials: true,
          });
          if (response.data.results && response.data.results.length > 0) {
            const headings = ['Source', 'Destination', 'Duration (sec)', 'Waiting Time (sec)', 'Call Type', 'Time/Date', 'Status'];
            const csvRows = response.data.results.map(item => [
              item.caller_id_number || item.source_number || '',
              item.caller_destination || item.destination_number || '',
              item.duration || '0',
              item.waiting_time ?? item.waitsec ?? '',
              item.direction || '',
              item.end_stamp
                ? new Date(item.end_stamp).toLocaleString()
                : (item.start_stamp ? new Date(item.start_stamp).toLocaleString() : ''),
              item.status || '',
            ]);
            const csvContent = [headings.join(','), ...csvRows.map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(','))].join('\n');
            const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(csvBlob, `${formData.get('keyword') || 'all'}-${startDateStr}-${endDateStr}-Extensive_Report.csv`);
          } else { alert('No call records found for the selected date range.'); }
        } catch (error) { console.error('Error fetching extensive report:', error); alert('Failed to generate report.'); }
        finally { setIsGenerating(false); }
      };

    // --- Graph Data Fetch Handlers ---

      const handlefetchPerformanceReport = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        try { 
            const response = await api.get('/report/performancereport/', {
              headers: { 'Authorization': `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
              withCredentials: true,
              params: { start_date: formData.get('start_date'), end_date: formData.get('end_date') },
            });
          const processedData = response.data.map((item) => ({
            name: item.user_name,
            received: Number(item.received),
            missed: Number(item.missed),
            not_found: Number(item.not_found),
            total_calls: Number(item.call_count),
            total_outgoing: Number(item.total_outgoing),
            total_incoming: Number(item.total_incoming),
          }));
          setChartData(processedData);
        } catch (error) { console.error('Error fetching performance report:', error); }
      };

      const handlefetchCallReport = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        try { 
            const response = await api.get('/report/callanalytics/', {
              headers: { 'Authorization': `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
              withCredentials: true,
              params: { start_date: formData.get('start_date'), end_date: formData.get('end_date') },
            });
          const processedData = response.data.map((item) => ({
            date: item.call_date.split('T')[0],
            received: Number(item.received) || 0,
            missed: Number(item.missed) || 0,
            not_found: Number(item.not_found) || 0,
            total_calls: Number(item.call_count) || 0,
            total_incoming: Number(item.incoming) || 0,
            total_outgoing: Number(item.outgoing) || 0,
            total_duration: Number(item.total_duration) || 0,
          }));
          setChartCallData(processedData);

          // Aggregate mix for pie chart (existing fields only)
          const totals = processedData.reduce((acc, row) => {
            acc.received += row.received;
            acc.missed += row.missed;
            acc.outgoing += row.total_outgoing;
            acc.incoming += row.total_incoming;
            return acc;
          }, { received: 0, missed: 0, outgoing: 0, incoming: 0 });
          setCallMixChartData([
            { name: 'Answered', value: totals.received },
            { name: 'Missed', value: totals.missed },
            { name: 'Outgoing', value: totals.outgoing },
            { name: 'Incoming', value: totals.incoming },
          ].filter(d => d.value > 0));
        } catch (error) { console.error('Error fetching performance report:', error); }
      };

      const handlefetchTalkTimeReport = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        try {
          const response = await api.get('/report/callanalytics/', {
            headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            withCredentials: true,
            params: {
              start_date: formData.get('start_date'),
              end_date: formData.get('end_date'),
            },
          });

          const rows = Array.isArray(response.data) ? response.data : (response.data?.data || []);
          const processedData = rows
            .map((item) => {
              const rawDate = item.call_date || item.date || item.day || '';
              const date =
                typeof rawDate === 'string' && rawDate.includes('T')
                  ? rawDate.split('T')[0]
                  : String(rawDate).slice(0, 10);

              // Prefer explicit seconds fields, then HH:MM:SS total_duration
              const seconds =
                timeToSeconds(
                  item.total_duration_seconds ??
                  item.total_seconds ??
                  item.duration_seconds ??
                  item.total_duration ??
                  item.duration ??
                  0
                );

              return {
                date: date || 'unknown',
                total_duration_seconds: seconds,
                total_duration_label: `${Math.floor(seconds / 3600)}:${String(Math.floor((seconds % 3600) / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`,
              };
            })
            .filter((row) => row.date && row.date !== 'unknown');

          setChartTalkTimeData(processedData);

          if (processedData.length === 0) {
            console.warn('[TalkTime] No rows after processing. Raw sample:', rows?.[0]);
          }
        } catch (error) {
          console.error('Error fetching talk time report:', error);
          setChartTalkTimeData([]);
        }
      };

      // Waiting time from FreeSWITCH extensive CDR (waiting_time / waitsec)
      const handlefetchWaitingStats = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        const start_date = formData.get('start_date');
        const end_date = formData.get('end_date');
        try {
          const response = await api.get('/report/extensivereport/', {
            params: {
              keyword: formData.get('keyword') || 'all',
              start_date,
              end_date,
            },
            headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            withCredentials: true,
          });

          const rows = response.data?.results || [];
          const byDate = {};
          let totalWait = 0;
          let countWithWait = 0;
          let maxWait = 0;

          rows.forEach((item) => {
            const wait = Number(item.waiting_time ?? item.waitsec ?? 0);
            if (!Number.isFinite(wait) || wait < 0) return;

            const stamp = item.start_stamp || item.end_stamp || item.insert_date;
            const dateKey = stamp
              ? new Date(stamp).toISOString().split('T')[0]
              : 'unknown';

            if (!byDate[dateKey]) {
              byDate[dateKey] = { date: dateKey, total_wait: 0, count: 0, max_wait: 0 };
            }
            byDate[dateKey].total_wait += wait;
            byDate[dateKey].count += 1;
            byDate[dateKey].max_wait = Math.max(byDate[dateKey].max_wait, wait);

            totalWait += wait;
            countWithWait += 1;
            maxWait = Math.max(maxWait, wait);
          });

          const chartRows = Object.values(byDate)
            .sort((a, b) => a.date.localeCompare(b.date))
            .map((d) => ({
              date: d.date,
              avg_wait: d.count ? Math.round(d.total_wait / d.count) : 0,
              max_wait: d.max_wait,
              calls: d.count,
            }));

          setWaitingChartData(chartRows);
          setWaitingSummary({
            avg_wait: countWithWait ? Math.round(totalWait / countWithWait) : 0,
            max_wait: maxWait,
            calls: countWithWait,
          });
        } catch (error) {
          console.error('Error fetching waiting time stats:', error);
          alert('Failed to load waiting time stats. Ensure extensive report / FreeSWITCH CDR is available.');
        }
      };
      
      // --- NEW GRAPH HANDLERS ---

      const handlefetchIndividualStats = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        try {
            const response = await api.get('/report/individualcallreport/', {
                params: {
                    keyword: formData.get('keyword'),
                    start_date: formData.get('start_date'),
                    end_date: formData.get('end_date'),
                    user_id: formData.get('user_id'),
                },
                headers: { Authorization: `Bearer ${authyToken}` },
                withCredentials: true,
            });
            
            // Aggregate data for the chart (e.g., Count by Call Status or Type)
            const statusCounts = response.data.reduce((acc, item) => {
                const status = item.call_duration || 'Unknown'; // call_duration holds status in some APIs, or use call_type
                acc[status] = (acc[status] || 0) + 1;
                return acc;
            }, {});

            const chartData = Object.keys(statusCounts).map(key => ({
                name: key,
                value: statusCounts[key]
            }));
            setIndividualChartData(chartData);
        } catch (error) {
            console.error('Error fetching individual stats:', error);
        }
      };

      const handlefetchTicketingStats = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        try {
            const response = await api.get('/report/ticketingreport/', {
                params: {
                    keyword: formData.get('keyword'),
                    start_date: formData.get('start_date'),
                    end_date: formData.get('end_date'),
                },
                headers: { Authorization: `Bearer ${authyToken}` },
                withCredentials: true,
            });

            // Count by Status
            const statusCounts = response.data.reduce((acc, item) => {
                const status = item.status || 'Unknown';
                acc[status] = (acc[status] || 0) + 1;
                return acc;
            }, {});

            const chartData = Object.keys(statusCounts).map(key => ({
                name: key,
                value: statusCounts[key]
            }));
            setTicketingChartData(chartData);
        } catch (error) {
            console.error('Error fetching ticketing stats:', error);
        }
      };

      const handlefetchDispositionStats = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        try {
            const response = await api.get('/report/dispositionreport/', {
                params: {
                    keyword: formData.get('keyword'),
                    start_date: formData.get('start_date'),
                    end_date: formData.get('end_date'),
                },
                headers: { Authorization: `Bearer ${authyToken}` },
                withCredentials: true,
            });

            // Count by Disposition Category
            const categoryCounts = response.data.reduce((acc, item) => {
                const cat = item.disposition_category || 'Unknown';
                acc[cat] = (acc[cat] || 0) + 1;
                return acc;
            }, {});

            const chartData = Object.keys(categoryCounts).map(key => ({
                name: key,
                count: categoryCounts[key]
            }));
            setDispositionChartData(chartData);
        } catch (error) {
            console.error('Error fetching disposition stats:', error);
        }
      };

      const handlefetchBreakStats = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        try {
            const response = await api.get('/report/breaksreport/', {
                params: {
                    keyword: formData.get('keyword'),
                    start_date: formData.get('start_date'),
                    end_date: formData.get('end_date'),
                },
                headers: { Authorization: `Bearer ${authyToken}` },
                withCredentials: true,
            });

            // Sum duration by User
            const userBreaks = {};
            response.data.forEach(item => {
                if(!item.start_time || !item.end_time) return;
                // Simple duration calc in minutes
                const start = new Date(`1970-01-01T${item.start_time}Z`);
                const end = new Date(`1970-01-01T${item.end_time}Z`);
                let diff = (end - start) / 60000; // minutes
                if(diff < 0) diff += 1440; // adjust for midnight cross

                if (!userBreaks[item.user_name]) userBreaks[item.user_name] = 0;
                userBreaks[item.user_name] += diff;
            });

            const chartData = Object.keys(userBreaks).map(key => ({
                name: key,
                minutes: Math.round(userBreaks[key])
            }));
            setBreakChartData(chartData);
        } catch (error) {
            console.error('Error fetching break stats:', error);
        }
      };

      const handlefetchLoginStats = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        try {
            const response = await api.get('/report/logingroupdata/', {
                params: {
                    keyword: formData.get('keyword'),
                    start_date: formData.get('start_date'),
                    end_date: formData.get('end_date'),
                },
                headers: { Authorization: `Bearer ${authyToken}` },
                withCredentials: true,
            });

            // Sum duration by User
            const userLogins = {};
            response.data.forEach(item => {
                const name = item.user_name;
                // Parse duration_readable (e.g., "1 h 20 m 10 s")
                let seconds = 0;
                if(item.duration_readable) {
                    const h = item.duration_readable.match(/(\d+)\s*h/);
                    const m = item.duration_readable.match(/(\d+)\s*m/);
                    const s = item.duration_readable.match(/(\d+)\s*s/);
                    if(h) seconds += parseInt(h[1]) * 3600;
                    if(m) seconds += parseInt(m[1]) * 60;
                    if(s) seconds += parseInt(s[1]);
                }
                
                if (!userLogins[name]) userLogins[name] = 0;
                userLogins[name] += seconds;
            });

            const chartData = Object.keys(userLogins).map(key => ({
                name: key,
                hours: parseFloat((userLogins[key] / 3600).toFixed(2))
            }));
            setLoginChartData(chartData);
        } catch (error) {
            console.error('Error fetching login stats:', error);
        }
      };

      useEffect(() => { fetchUsersData(); fetchTicketingCategoryGroup(); fetchDispositionCategoryGroup(); fetchBreakGroup(); fetchLoginData(); }, []);

    return (
        <>
            <CssBaseline />
                <Typography variant='h5' sx={{marginBottom:'15px'}}>
                    Analytics
                </Typography>

                <Tabs value={activeTab} onChange={handleTabChange} variant="fullWidth" aria-label="Profile Tabs" sx={{padding:'2px',marginBottom:'15px'}}>
                    <Tab label="REPORTS"/>
                    <Tab label="STATS GRAPH"/>
                </Tabs>

                {/* REPORTS TAB (Preserved Original) */}
                {activeTab === 0 && (
                    <>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <Box sx={{bgcolor:'background.paper', boxShadow: 'none', border: `0.1px solid rgba(207, 211, 212, 0.2)`, borderRadius: '5px'}}>
                                    <Tabs value={activeMiniTab} onChange={handleMiniTabChange} variant="fullWidth" aria-label="Profile Tabs" sx={{padding:'0px'}}>
                                        <Tab label="CALLS"/>
                                        <Tab label="INDIVIDUAL"/>
                                        <Tab label="TICKETING"/>
                                        <Tab label="DISPOSITION"/>
                                        <Tab label="PERFORMANCE"/>
                                        <Tab label="BREAKS"/>
                                        <Tab label="CONTACTS"/>
                                        <Tab label="EXTENSIVE"/>
                                        <Tab label="LOGIN STAMPS"/>
                                    </Tabs>

                                    {activeMiniTab === 0 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handleCallReportSubmit}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12}>
                                                        <TextField fullWidth select label="Select Call Report" name="keyword" value={formData.keyword || ''} onChange={handleInputChange} sx={{marginTop:"5px"}} required>
                                                            <MenuItem disabled>Select Report</MenuItem>
                                                            <MenuItem value="all">All</MenuItem>
                                                            <MenuItem value="Received">Answered</MenuItem>
                                                            <MenuItem value="Busy">Busy</MenuItem>
                                                            <MenuItem value="Rejected">Rejected</MenuItem>
                                                            <MenuItem value="No Answer">No Answer</MenuItem>
                                                            <MenuItem value="Incoming">Incoming</MenuItem>
                                                            <MenuItem value="Outgoing">Outgoing</MenuItem>
                                                            <MenuItem value="Missed">Missed</MenuItem>
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label sx={{textAlign:'left'}}>Start Date</label>
                                                        <TextField name="start_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                        <TextField name="report" value="Call" sx={{display:'none!important'}} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label>End Date</label>
                                                        <TextField name="end_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button variant="contained" color="primary" type="submit">Extract Call Report</Button>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </Box>
                                    )}

                                    {activeMiniTab === 1 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handleIndividualCallReportSubmit}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField fullWidth select label="Select Individual" name="user_id" value={formData.user_id || ''} onChange={handleInputChange} required sx={{marginTop:"5px"}}>
                                                            <MenuItem value="">Select Individual</MenuItem>
                                                            { usersData.map((row) => (
                                                                <MenuItem key={row.user_id} value={row.user_id}>{row.user_name} ({row.user_extension})</MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField fullWidth select name="keyword" sx={{marginTop:"5px"}} label="Select Report" value={formData.keyword || ''} onChange={handleInputChange} required>
                                                            <MenuItem disabled>Select Report</MenuItem>
                                                            <MenuItem value="all">All</MenuItem>
                                                            <MenuItem value="Received">Answered</MenuItem>
                                                            <MenuItem value="Busy">Busy</MenuItem>
                                                            <MenuItem value="Rejected">Rejected</MenuItem>
                                                            <MenuItem value="No Answer">No Answer</MenuItem>
                                                            <MenuItem value="Incoming">Incoming</MenuItem>
                                                            <MenuItem value="Outgoing">Outgoing</MenuItem>
                                                            <MenuItem value="Missed">Missed</MenuItem>
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label sx={{textAlign:'left'}}>Start Date</label>
                                                        <TextField name="start_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                        <TextField name="report" value="Call" sx={{display:'none!important'}} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label>End Date</label>
                                                        <TextField name="end_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button variant="contained" color="primary" type="submit">Extract Individual Call Report</Button>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </Box>
                                    )}

                                    {activeMiniTab === 2 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handleTicketingReport}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12}>
                                                        <TextField fullWidth select label="Ticketing Category" name="keyword" value={formData.keyword || ''} onChange={handleInputChange} required sx={{marginTop:"5px"}}>
                                                            <MenuItem value="" disabled>Ticketing Category</MenuItem>
                                                            <MenuItem value="all">All</MenuItem>
                                                            { ticketingGroupData.map((row) => (
                                                                <MenuItem key={row.category} value={row.category}>{row.category}</MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label sx={{textAlign:'left'}}>Start Date</label>
                                                        <TextField name="start_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label>End Date</label>
                                                        <TextField name="end_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button variant="contained" color="primary" type="submit">Extract Ticketing Report</Button>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </Box>
                                    )}

                                    {activeMiniTab === 3 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handleDispositionReport}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12}>
                                                        <TextField fullWidth select label="Select Dispostion" name="keyword" value={formData.keyword || ''} onChange={handleInputChange} required sx={{marginTop:"5px"}}>
                                                            <MenuItem value="" disabled>Select Dispostion</MenuItem>
                                                            <MenuItem value="all">All</MenuItem>
                                                            { dispostionGroupData.map((row) => (
                                                                <MenuItem key={row.disposition} value={row.disposition}>{row.disposition}</MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label sx={{textAlign:'left'}}>Start Date</label>
                                                        <TextField name="start_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label>End Date</label>
                                                        <TextField name="end_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button variant="contained" color="primary" type="submit">Extract Disposition Report</Button>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </Box>
                                    )}

                                    {activeMiniTab === 4 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handlePerformanceReportSubmit}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12}>Extract Call Performance</Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label sx={{textAlign:'left'}}>Start Date</label>
                                                        <TextField name="start_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label>End Date</label>
                                                        <TextField name="end_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button variant="contained" color="primary" type="submit">Extract Performance Report</Button>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </Box>
                                    )}

                                    {activeMiniTab === 5 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handleBreakReportSubmit}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12}>
                                                        <TextField fullWidth select label="Select Break" name="keyword" value={formData.keyword || ''} onChange={handleInputChange} required sx={{marginTop:"5px"}}>
                                                            <MenuItem value="" disabled>Select Break</MenuItem>
                                                            <MenuItem value="all">All</MenuItem>
                                                            { breakGroupData.map((row) => (
                                                                <MenuItem key={row.break} value={row.break}>{row.break}</MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label sx={{textAlign:'left'}}>Start Date</label>
                                                        <TextField name="start_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label>End Date</label>
                                                        <TextField name="end_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button variant="contained" color="primary" type="submit">Extract Break Report</Button>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </Box>
                                    )}

                                    {activeMiniTab === 6 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handleContactReportSubmit}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}><label>Extract All Contacts</label></Grid>
                                                    <Grid item xs={12}>
                                                        <Button variant="contained" color="primary" type="submit" fullWidth>Extract All Contacts</Button>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </Box>
                                    )}

                                    {activeMiniTab === 7 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={(e) => handleExtensiveReportSubmit(e, setIsGenerating)}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12}>
                                                        <TextField fullWidth select label="Select Report" name="keyword" value={formData.keyword || ''} onChange={handleInputChange} required sx={{marginTop:"5px"}}>
                                                            <MenuItem value="" disabled>Select Report</MenuItem>
                                                            <MenuItem value="failed">Failed</MenuItem>
                                                            <MenuItem value="cancelled">Cancelled</MenuItem>
                                                            <MenuItem value="answered">Answered</MenuItem>
                                                            <MenuItem value="no_answer">No Answered</MenuItem>
                                                            <MenuItem value="busy">Busy</MenuItem>
                                                            <MenuItem value="missed">Missed</MenuItem>
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label sx={{textAlign:'left'}}>Start Date</label>
                                                        <TextField name="start_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label>End Date</label>
                                                        <TextField name="end_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button type="submit" color="primary" variant="contained" disabled={isGenerating} style={{ opacity: isGenerating ? 0.7 : 1 }}>
                                                            {isGenerating ? 'Generating Report...' : 'Generate Extensive Report'}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </Box>
                                    )}

                                    {activeMiniTab === 8 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={(e) => handleLoginReportSubmit(e, setIsGenerating)}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={12}>
                                                        <TextField fullWidth select label="Select User" name="keyword" value={formData.keyword || ''} onChange={handleInputChange} required sx={{marginTop:"5px"}}>
                                                            <MenuItem value="" disabled>Select User</MenuItem>
                                                            <MenuItem value="all">All</MenuItem>
                                                            { loginData.map((row) => (
                                                                <MenuItem key={row.user_name} value={row.user_name}>{row.user_name}</MenuItem>
                                                            ))}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label sx={{textAlign:'left'}}>Start Date</label>
                                                        <TextField name="start_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label>End Date</label>
                                                        <TextField name="end_date" type="date" onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button type="submit" color="primary" variant="contained" disabled={isGenerating} style={{ opacity: isGenerating ? 0.7 : 1 }}>
                                                            {isGenerating ? 'Generating Report...' : 'Generate Login Report'}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </>
                )}

                {/* STATS GRAPH TAB (Updated) */}
                {activeTab === 1 && (

                  
                    <>


                                            <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <Box sx={{bgcolor:'background.paper', boxShadow: 'none', border: `0.1px solid rgba(207, 211, 212, 0.2)`, borderRadius: '5px', maxWidth: '100%', overflow: 'hidden'}}>
                                    <Tabs
                                        value={activeMini2Tab}
                                        onChange={handleMini2TabChange}
                                        variant="fullWidth"
                                        aria-label="Stats Graph Tabs"
                                        sx={{
                                            padding: 0,
                                            minHeight: 48,
                                            '& .MuiTab-root': {
                                                minWidth: 0,
                                                flex: 1,
                                                fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.8rem' },
                                                px: { xs: 0.25, sm: 0.5 },
                                                textTransform: 'none',
                                            },
                                        }}
                                    >
                                        <Tab label="CALLS"/>
                                        <Tab label="INDIVIDUAL"/>
                                        <Tab label="TICKETING"/>
                                        <Tab label="DISPOSITIONS"/>
                                        <Tab label="PERFORMANCE"/>
                                        <Tab label="BREAKS"/>
                                        <Tab label="LOGIN"/>
                                        <Tab label="TALK TIME"/>
                                        <Tab label="WAITING"/>
                                    </Tabs>

                                    {/* Calls Graph */}
                                    {activeMini2Tab === 0 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handlefetchCallReport}> 
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={3}><label sx={{textAlign:'left'}}>Start Date</label><TextField name="start_date" type="date" value={formData.start_date || ''} onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={12} sm={3}><label>End Date</label><TextField name="end_date" type="date" value={formData.end_date || ''} onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={6} sm={3}><Button variant="contained" color="primary" type="submit" sx={{padding:'14px',marginTop:"30px"}} fullWidth>Generate</Button></Grid>
                                                    <Grid item xs={6} sm={3}><Button variant="outlined" color="inherit" type="button" onClick={() => resetStatsGraphTab(0)} sx={{padding:'14px',marginTop:"30px"}} fullWidth>Reset</Button></Grid>
                                                </Grid>
                                            </form>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={8}>            
                                                    {chartCallData.length > 0 && (
                                                        <Box sx={chartBoxSx}>
                                                            <Typography variant="h6" gutterBottom>Call Volume by Day</Typography>
                                                            <ResponsiveContainer width="100%" height="100%">
                                                                <BarChart data={chartCallData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                                                    <CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="date" /><YAxis /><Tooltip /><Legend />
                                                                    <Bar dataKey="received" stackId="status" fill="#5CB338" name="Answered"/>
                                                                    <Bar dataKey="missed" stackId="status" fill="#FF0000" name="Missed"/>
                                                                    <Bar dataKey="total_outgoing" stackId="dir" fill="#FFA500" name="Outgoing"/>
                                                                    <Bar dataKey="total_incoming" stackId="dir" fill="#79B6BC" name="Incoming"/>
                                                                </BarChart>
                                                            </ResponsiveContainer>
                                                        </Box>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                    {callMixChartData.length > 0 && (
                                                        <Box sx={chartBoxSx}>
                                                            <Typography variant="h6" gutterBottom>Period Mix</Typography>
                                                            <ResponsiveContainer width="100%" height="100%">
                                                                <PieChart>
                                                                    <Pie data={callMixChartData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={110} label>
                                                                        {callMixChartData.map((entry, index) => (
                                                                            <Cell key={`cell-${index}`} fill={PIE_COLORS[index % PIE_COLORS.length]} />
                                                                        ))}
                                                                    </Pie>
                                                                    <Tooltip /><Legend />
                                                                </PieChart>
                                                            </ResponsiveContainer>
                                                        </Box>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    )}

                                    {/* Individual Graph */}
                                    {activeMini2Tab === 1 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handlefetchIndividualStats}> 
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField fullWidth select label="Select Individual" name="user_id" value={formData.user_id || ''} onChange={handleInputChange} required>
                                                            <MenuItem value="">Select Individual</MenuItem>
                                                            { usersData.map((row) => (<MenuItem key={row.user_id} value={row.user_id}>{row.user_name}</MenuItem>))}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={3}><TextField fullWidth select name="keyword" label="Call Type" value={formData.keyword || ''} onChange={handleInputChange} required><MenuItem value="all">All</MenuItem><MenuItem value="Received">Answered</MenuItem><MenuItem value="Missed">Missed</MenuItem></TextField></Grid>
                                                    <Grid item xs={12} sm={3}><TextField name="start_date" type="date" value={formData.start_date || ''} onChange={handleInputChange} fullWidth required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={12} sm={3}><TextField name="end_date" type="date" value={formData.end_date || ''} onChange={handleInputChange} fullWidth required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={6} sm={6}><Button variant="contained" color="primary" type="submit" fullWidth>Generate Graph</Button></Grid>
                                                    <Grid item xs={6} sm={6}><Button variant="outlined" color="inherit" type="button" onClick={() => resetStatsGraphTab(1)} fullWidth>Reset</Button></Grid>
                                                </Grid>
                                            </form>
                                            {individualChartData.length > 0 && (
                                                <Box sx={chartBoxSx}>
                                                    <Typography variant="h6" gutterBottom>Individual Call Stats</Typography>
                                                    <ResponsiveContainer width="100%" height="100%">
                                                        <BarChart data={individualChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                                            <CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="name" /><YAxis /><Tooltip /><Legend />
                                                            <Bar dataKey="value" fill="#8884d8" name="Call Count" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                </Box>
                                            )}
                                        </Box>
                                    )}

                                    {/* Ticketing Graph */}
                                    {activeMini2Tab === 2 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handlefetchTicketingStats}> 
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={4}>
                                                        <TextField fullWidth select label="Category" name="keyword" value={formData.keyword || ''} onChange={handleInputChange} required>
                                                            <MenuItem value="all">All</MenuItem>
                                                            {ticketingGroupData.map((row) => (<MenuItem key={row.category} value={row.category}>{row.category}</MenuItem>))}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}><TextField name="start_date" type="date" value={formData.start_date || ''} onChange={handleInputChange} fullWidth required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={12} sm={4}><TextField name="end_date" type="date" value={formData.end_date || ''} onChange={handleInputChange} fullWidth required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={6} sm={6}><Button variant="contained" color="primary" type="submit" fullWidth>Generate Graph</Button></Grid>
                                                    <Grid item xs={6} sm={6}><Button variant="outlined" color="inherit" type="button" onClick={() => resetStatsGraphTab(2)} fullWidth>Reset</Button></Grid>
                                                </Grid>
                                            </form>
                                            {ticketingChartData.length > 0 && (
                                                <Box sx={chartBoxSx}>
                                                    <Typography variant="h6" gutterBottom>Ticketing Status Distribution</Typography>
                                                    <ResponsiveContainer width="100%" height="100%">
                                                        <BarChart data={ticketingChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                                            <CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="name" /><YAxis /><Tooltip /><Legend />
                                                            <Bar dataKey="value" fill="#82ca9d" name="Tickets" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                </Box>
                                            )}
                                        </Box>
                                    )}

                                    {/* Dispositions Graph */}
                                    {activeMini2Tab === 3 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handlefetchDispositionStats}> 
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={4}>
                                                        <TextField fullWidth select label="Disposition" name="keyword" value={formData.keyword || ''} onChange={handleInputChange} required>
                                                            <MenuItem value="all">All</MenuItem>
                                                            {dispostionGroupData.map((row) => (<MenuItem key={row.disposition} value={row.disposition}>{row.disposition}</MenuItem>))}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}><TextField name="start_date" type="date" value={formData.start_date || ''} onChange={handleInputChange} fullWidth required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={12} sm={4}><TextField name="end_date" type="date" value={formData.end_date || ''} onChange={handleInputChange} fullWidth required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={6} sm={6}><Button variant="contained" color="primary" type="submit" fullWidth>Generate Graph</Button></Grid>
                                                    <Grid item xs={6} sm={6}><Button variant="outlined" color="inherit" type="button" onClick={() => resetStatsGraphTab(3)} fullWidth>Reset</Button></Grid>
                                                </Grid>
                                            </form>
                                            {dispositionChartData.length > 0 && (
                                                <Box sx={chartBoxSx}>
                                                    <Typography variant="h6" gutterBottom>Disposition Category Count</Typography>
                                                    <ResponsiveContainer width="100%" height="100%">
                                                        <BarChart data={dispositionChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                                            <CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="name" /><YAxis /><Tooltip /><Legend />
                                                            <Bar dataKey="count" fill="#ffc658" name="Count" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                </Box>
                                            )}
                                        </Box>
                                    )}

                                    {/* Performance Graph */}
                                    {activeMini2Tab === 4 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handlefetchPerformanceReport}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={3}><label>Start Date</label><TextField name="start_date" type="date" value={formData.start_date || ''} onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={12} sm={3}><label>End Date</label><TextField name="end_date" type="date" value={formData.end_date || ''} onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={6} sm={3}><Button variant="contained" color="primary" type="submit" sx={{padding:'14px',marginTop:"30px"}} fullWidth>Generate</Button></Grid>
                                                    <Grid item xs={6} sm={3}><Button variant="outlined" color="inherit" type="button" onClick={() => resetStatsGraphTab(4)} sx={{padding:'14px',marginTop:"30px"}} fullWidth>Reset</Button></Grid>
                                                </Grid>
                                            </form>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={12}>            
                                                    {chartData.length > 0 && (
                                                        <Box sx={{ ...chartBoxSx, height: Math.min(700, Math.max(380, chartData.length * 48)), overflowX: 'hidden', overflowY: 'auto' }}>
                                                            <Typography variant="h6" gutterBottom>Call Performance Report</Typography>
                                                            <ResponsiveContainer width="100%" height="100%">
                                                                <BarChart data={chartData} margin={{ top: 20, right: 50, left: 50, bottom: 80 }}>
                                                                    <CartesianGrid strokeDasharray="3 3" />
                                                                    <XAxis dataKey="name" angle={-45} textAnchor="end" height={80} interval={0} fontSize={12} />
                                                                    <YAxis width={60} fontSize={12} />
                                                                    <Tooltip /><Legend verticalAlign="top" height={50} />
                                                                    <Bar dataKey="received" stackId="status" fill="#5CB338" name="Received"/>
                                                                    <Bar dataKey="missed" stackId="status" fill="#FF0000" name="Missed"/>
                                                                    <Bar dataKey="total_outgoing" stackId="direction" fill="#FFA500" name="Outgoing"/>
                                                                    <Bar dataKey="total_incoming" stackId="direction" fill="#79B6BC" name="Incoming"/>
                                                                </BarChart>
                                                            </ResponsiveContainer>
                                                        </Box>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    )}

                                    {/* Breaks Graph */}
                                    {activeMini2Tab === 5 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handlefetchBreakStats}> 
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={4}>
                                                        <TextField fullWidth select label="Break Type" name="keyword" value={formData.keyword || ''} onChange={handleInputChange} required>
                                                            <MenuItem value="all">All</MenuItem>
                                                            {breakGroupData.map((row) => (<MenuItem key={row.break} value={row.break}>{row.break}</MenuItem>))}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}><TextField name="start_date" type="date" value={formData.start_date || ''} onChange={handleInputChange} fullWidth required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={12} sm={4}><TextField name="end_date" type="date" value={formData.end_date || ''} onChange={handleInputChange} fullWidth required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={6} sm={6}><Button variant="contained" color="primary" type="submit" fullWidth>Generate Graph</Button></Grid>
                                                    <Grid item xs={6} sm={6}><Button variant="outlined" color="inherit" type="button" onClick={() => resetStatsGraphTab(5)} fullWidth>Reset</Button></Grid>
                                                </Grid>
                                            </form>
                                            {breakChartData.length > 0 && (
                                                <Box sx={chartBoxSx}>
                                                    <Typography variant="h6" gutterBottom>Total Break Duration (Minutes)</Typography>
                                                    <ResponsiveContainer width="100%" height="100%">
                                                        <BarChart data={breakChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                                            <CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="name" /><YAxis /><Tooltip /><Legend />
                                                            <Bar dataKey="minutes" fill="#d32f2f" name="Minutes" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                </Box>
                                            )}
                                        </Box>
                                    )}

                                    {/* Login Stamps Graph */}
                                    {activeMini2Tab === 6 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handlefetchLoginStats}> 
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={4}>
                                                        <TextField fullWidth select label="User" name="keyword" value={formData.keyword || ''} onChange={handleInputChange} required>
                                                            <MenuItem value="all">All</MenuItem>
                                                            {loginData.map((row) => (<MenuItem key={row.user_name} value={row.user_name}>{row.user_name}</MenuItem>))}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}><TextField name="start_date" type="date" value={formData.start_date || ''} onChange={handleInputChange} fullWidth required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={12} sm={4}><TextField name="end_date" type="date" value={formData.end_date || ''} onChange={handleInputChange} fullWidth required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={6} sm={6}><Button variant="contained" color="primary" type="submit" fullWidth>Generate Graph</Button></Grid>
                                                    <Grid item xs={6} sm={6}><Button variant="outlined" color="inherit" type="button" onClick={() => resetStatsGraphTab(6)} fullWidth>Reset</Button></Grid>
                                                </Grid>
                                            </form>
                                            {loginChartData.length > 0 && (
                                                <Box sx={chartBoxSx}>
                                                    <Typography variant="h6" gutterBottom>Total Login Duration (Hours)</Typography>
                                                    <ResponsiveContainer width="100%" height="100%">
                                                        <BarChart data={loginChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                                            <CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="name" /><YAxis /><Tooltip /><Legend />
                                                            <Bar dataKey="hours" fill="#3f51b5" name="Hours" />
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                </Box>
                                            )}
                                        </Box>
                                    )}

                                    {/* Talk Time Graph */}
                                    {activeMini2Tab === 7 && (
                                        <Box sx={{ padding: '15px', maxWidth: '100%', overflow: 'hidden' }}>
                                            <form onSubmit={handlefetchTalkTimeReport}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={3}><label>Start Date</label><TextField name="start_date" type="date" value={formData.start_date || ''} onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={12} sm={3}><label>End Date</label><TextField name="end_date" type="date" value={formData.end_date || ''} onChange={handleInputChange} fullWidth sx={{marginTop:"10px"}} variant="outlined" required inputProps={{ max: today }}/></Grid>
                                                    <Grid item xs={6} sm={3}><Button variant="contained" color="primary" type="submit" sx={{padding:'14px',marginTop:"30px"}} fullWidth>Generate</Button></Grid>
                                                    <Grid item xs={6} sm={3}><Button variant="outlined" color="inherit" type="button" onClick={() => resetStatsGraphTab(7)} sx={{padding:'14px',marginTop:"30px"}} fullWidth>Reset</Button></Grid>
                                                </Grid>
                                            </form>
                                            <Grid container spacing={2} sx={{ maxWidth: '100%' }}>
                                                <Grid item xs={12}>
                                                    {chartTalkTimeData.length > 0 ? (
                                                        <>
                                                            <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>Talk Time by Day</Typography>
                                                            <Box sx={chartBoxSx}>
                                                                <ResponsiveContainer width="100%" height="100%">
                                                                    <AreaChart data={chartTalkTimeData} margin={{ top: 16, right: 24, left: 8, bottom: 8 }}>
                                                                        <CartesianGrid strokeDasharray="3 3" />
                                                                        <XAxis dataKey="date" tick={{ fontSize: 12 }} />
                                                                        <YAxis
                                                                          tick={{ fontSize: 12 }}
                                                                          label={{ value: 'Seconds', angle: -90, position: 'insideLeft', style: { fontSize: 12 } }}
                                                                        />
                                                                        <Tooltip
                                                                          formatter={(value, name) => {
                                                                            if (name === 'total_duration_seconds' || name === 'Duration (s)') {
                                                                              const s = Number(value) || 0;
                                                                              const h = Math.floor(s / 3600);
                                                                              const m = Math.floor((s % 3600) / 60);
                                                                              const sec = s % 60;
                                                                              return [`${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')} (${s}s)`, 'Talk time'];
                                                                            }
                                                                            return [value, name];
                                                                          }}
                                                                        />
                                                                        <Legend />
                                                                        <Area type="monotone" dataKey="total_duration_seconds" stroke="#8884d8" fill="#8884d8" name="Duration (s)" />
                                                                    </AreaChart>
                                                                </ResponsiveContainer>
                                                            </Box>
                                                        </>
                                                    ) : (<></>)}
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    )}

                                    {/* Waiting Time Graph (from FreeSWITCH extensive CDR) */}
                                    {activeMini2Tab === 8 && (
                                        <Box sx={{padding:'15px'}}>
                                            <form onSubmit={handlefetchWaitingStats}>
                                                <Grid container spacing={2} alignItems="flex-end">
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            fullWidth
                                                            select
                                                            label="Status filter"
                                                            name="keyword"
                                                            value={formData.keyword || 'all'}
                                                            onChange={handleInputChange}
                                                            variant="outlined"
                                                        >
                                                            <MenuItem value="all">All</MenuItem>
                                                            <MenuItem value="answered">Answered</MenuItem>
                                                            <MenuItem value="missed">Missed</MenuItem>
                                                            <MenuItem value="no_answer">No Answer</MenuItem>
                                                            <MenuItem value="busy">Busy</MenuItem>
                                                            <MenuItem value="cancelled">Cancelled</MenuItem>
                                                            <MenuItem value="failed">Failed</MenuItem>
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField
                                                            name="start_date"
                                                            type="date"
                                                            label="Start Date"
                                                            value={formData.start_date || ''}
                                                            onChange={handleInputChange}
                                                            fullWidth
                                                            variant="outlined"
                                                            required
                                                            InputLabelProps={{ shrink: true }}
                                                            inputProps={{ max: today }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <TextField
                                                            name="end_date"
                                                            type="date"
                                                            label="End Date"
                                                            value={formData.end_date || ''}
                                                            onChange={handleInputChange}
                                                            fullWidth
                                                            variant="outlined"
                                                            required
                                                            InputLabelProps={{ shrink: true }}
                                                            inputProps={{ max: today }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6} sm={2}>
                                                        <Button variant="contained" color="primary" type="submit" fullWidth sx={{ height: 56 }}>
                                                            Generate
                                                        </Button>
                                                    </Grid>
                                                    <Grid item xs={6} sm={3}>
                                                        <Button variant="outlined" color="inherit" type="button" onClick={() => resetStatsGraphTab(8)} fullWidth sx={{ height: 56 }}>
                                                            Reset
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </form>

                                            {waitingSummary && (
                                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                                    <Grid item xs={12} sm={4}>
                                                        <Box sx={{ p: 2, borderRadius: 2, border: '1px solid rgba(207,211,212,0.3)' }}>
                                                            <Typography variant="body2" color="text.secondary">Avg waiting time</Typography>
                                                            <Typography variant="h5">{waitingSummary.avg_wait}s</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <Box sx={{ p: 2, borderRadius: 2, border: '1px solid rgba(207,211,212,0.3)' }}>
                                                            <Typography variant="body2" color="text.secondary">Max waiting time</Typography>
                                                            <Typography variant="h5">{waitingSummary.max_wait}s</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <Box sx={{ p: 2, borderRadius: 2, border: '1px solid rgba(207,211,212,0.3)' }}>
                                                            <Typography variant="body2" color="text.secondary">Calls with wait data</Typography>
                                                            <Typography variant="h5">{waitingSummary.calls}</Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            )}

                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    {waitingChartData.length > 0 && (
                                                        <Box sx={chartBoxSx}>
                                                            <Typography variant="h6" gutterBottom>Average & Max Waiting Time by Day (seconds)</Typography>
                                                            <ResponsiveContainer width="100%" height="100%">
                                                                <BarChart data={waitingChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                                                    <CartesianGrid strokeDasharray="3 3" />
                                                                    <XAxis dataKey="date" />
                                                                    <YAxis />
                                                                    <Tooltip />
                                                                    <Legend />
                                                                    <Bar dataKey="avg_wait" fill="#3f51b5" name="Avg wait (s)" />
                                                                    <Bar dataKey="max_wait" fill="#ff9800" name="Max wait (s)" />
                                                                </BarChart>
                                                            </ResponsiveContainer>
                                                        </Box>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    {waitingChartData.length > 0 && (
                                                        <Box sx={{ ...chartBoxSx, height: 300, mt: 1 }}>
                                                            <Typography variant="h6" gutterBottom>Call count with wait data</Typography>
                                                            <ResponsiveContainer width="100%" height="100%">
                                                                <AreaChart data={waitingChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                                                    <CartesianGrid strokeDasharray="3 3" />
                                                                    <XAxis dataKey="date" />
                                                                    <YAxis />
                                                                    <Tooltip />
                                                                    <Legend />
                                                                    <Area type="monotone" dataKey="calls" stroke="#79B6BC" fill="#79B6BC" name="Calls" />
                                                                </AreaChart>
                                                            </ResponsiveContainer>
                                                        </Box>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </>
                )}
        </>
    );
};

export default Analyticz;